import React, { useRef, useMemo } from 'react';
import { DuperbrowseItemId } from '../../Duperbrowse/redux/types';
import useDuperbrowseScrollRestoration from '../../Duperbrowse/hooks/useDuperbrowseScrollRestoration';
import gridStyle from './GridRow.scss';

export interface Props {
  start: number;
  end: number;
  height: number;
  marginTop?: number;
  getDuperbrowseItemId?: (index: number) => DuperbrowseItemId | undefined;
}

const HiddenGridRow: React.FC<Props> = ({
  start,
  end,
  getDuperbrowseItemId,
  marginTop,
  height,
}) => {
  const itemIds: DuperbrowseItemId[] = useMemo(() => {
    return getDuperbrowseItemId
      ? Array(end - start)
          .fill(0)
          .map((_, i) => getDuperbrowseItemId(i + start)!)
      : [];
  }, [start, end, getDuperbrowseItemId]);

  const rowRef = useRef<HTMLDivElement>(null);
  useDuperbrowseScrollRestoration(itemIds, rowRef);

  return <div className={gridStyle['row']} style={{ marginTop, height }} ref={rowRef} />;
};
HiddenGridRow.displayName = 'HiddenGridRow';

export default HiddenGridRow;
